import $ from 'jquery';
import {is_function} from '../../Helpers/js';

$.initialize('[data-role="datepicker"]', function () {
  var $me = $(this),
    options = {type: $me.data('type')},
    endCalendar = $me.data('end-calendar'),
    startCalendar = $me.data('start-calendar');

  if (endCalendar) {
    options.endCalendar = $(document).find('[data-name="' + endCalendar + '"]');
  }
  if (startCalendar) {
    options.startCalendar = $(document).find('[data-name="' + startCalendar + '"]');
  }

  setTimeout(function () {
    $me.datepicker(options);
  }, 1);
});

$.widget('lp.datepicker', {
  input: null,
  options: {
    type: 'date', // can be datetime, date, time, month, or year
    firstDayOfWeek: 1,
    selectAdjacentDays: true,
    lang: '',
    ampm: false,
  },

  texts: {
    en: {
      days: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      today: 'Today',
      now: 'Now',
      am: 'AM',
      pm: 'PM',
    },
    de: {
      days: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
      months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
      monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
      today: 'Heute',
      now: 'Jetzt',
      am: 'AM',
      pm: 'PM',
    },
  },

  _create: function () {
    var that = this,
      name = 'date',
      dateId = '';

    var input = this.element.find('input');
    if (input.length > 0) {
      name = input.attr('name');
      dateId = input.attr('id');
      input.removeAttr('name');
    } else if (this.element.data('name')) {
      name = this.element.data('name');
    }
    //initialDate
    this.options.lang = this.options.lang || this.getLanguage();

    if (this.options.lang in this.texts) {
      this.options.text = this.texts[this.options.lang];
    } else {
      this.options.text = this.texts['en'];
    }

    /** Das AM/PM Uhrzeit-Format im CalendarPopup ist nur für die englische Sprache angezeigt. Für alle anderen Sprachen ist das 24-Stunden-Format angezeigt **/
    this.options.ampm = this.options.lang === 'en';

    if (!this.options.inline) {
      this.options.onChange = function (date, text, mode) {
        that.onChange(this, date, text, mode);
      };
    }

    this.options.monthFirst = this.options.lang != 'de';
    this.options.formatter = {
      date: this.options.lang === 'en' ? 'MMM DD, YYYY' : 'DD. MMM YYYY',
      datetime: this.options.lang === 'en' ? 'MMM DD, YYYY hh:mm A' : 'DD. MMM YYYY,  HH:mm',
      time: this.options.lang === 'en' ? 'hh:mm A' : 'HH:mm',
      cellTime: this.options.lang === 'en' ? 'hh:mm A' : 'HH:mm',
    };

    this.element.calendar(this.options);
    this.input = $('<input type="hidden" id="' + dateId + '-hidden" name="' + name + '" value="' + this.getInputValueFormat(this.element.calendar('get date')) + '">');
    if (this.options.inline) {
      this.input.appendTo(this.element);
    } else if (input.length > 0) {
      this.input.insertAfter(input.closest('.ui.calendar'));
    }
  },

  onChange: function (trigger, date) {
    var d = this.getInputValueFormat(date);
    this.input.val(d);
    if (is_function(this.options.onChanged)) {
      this.options.onChanged(d);
    }
  },

  getInputValueFormat: function (date) {
    var d;
    switch (this.options.type) {
      case 'date':
        d = this.formatter.date(date);
        break;
      case 'time':
        d = this.formatter.time(date);
        break;
      case 'datetime':
        d = this.formatter.date(date) + ' ' + this.formatter.time(date);
        break;
    }

    return d;
  },

  getDate: function () {
    return this.formatter.date(this.element.calendar('get date'));
  },

  getTime: function () {
    return this.formatter.time(this.element.calendar('get date'));
  },

  formatter: {
    date: function (date) {
      if (typeof date === 'object' && date !== null) {
        return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
      } else {
        return '';
      }
    },
    time: function (date) {
      if (typeof date === 'object' && date !== null) {
        return ('0' + date.getHours()).slice(-2) + ':' + ('0' + date.getMinutes()).slice(-2);
      } else {
        return '';
      }
    },
  },

  getLanguage() {
    return document.getElementsByTagName('html')[0].lang || 'en';
  },
});
